import React, {Component} from "react";
import {Layout, Popover, Breadcrumb, Button, Icon, Avatar, Row, Col} from "antd";
import {Link} from "react-router-dom";

import languageData from "./languageData";
import {switchLanguage, toggleCollapsedSideNav} from "../../appRedux/actions/Setting";
import {changeApplication, clearApplications} from "../../appRedux/actions/Application";
import {userSignOut} from "../../appRedux/actions/Auth";
import SearchBox from "components/SearchBox";
import UserInfo from "components/UserInfo";
import AppNotification from "components/AppNotification";
import MailNotification from "components/MailNotification";
import Auxiliary from "util/Auxiliary";
import {history} from "appRedux/store";

import {
  fetchWifiTests
} from "appRedux/actions/Device";

import {
  readNotification
} from "appRedux/actions/Websocket";


import {NAV_STYLE_DRAWER, NAV_STYLE_FIXED, NAV_STYLE_MINI_SIDEBAR, TAB_SIZE} from "../../constants/ThemeSetting";
import {connect} from "react-redux";

const {Header} = Layout;

class Topbar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchText: ''
    };
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.selectedApplication && this.props.selectedApplication) {
      const {selectedApplication} = this.props;
      console.log('selectedApplication', selectedApplication);

      if (selectedApplication) {
          console.log('fetchWifiTests');
          this.props.fetchWifiTests(selectedApplication.applicationId);
      }
    }
  }

  languageMenu = () => (

      <ul className="gx-sub-popover">
        {languageData.map(language =>
          <li className="gx-media gx-pointer" key={JSON.stringify(language)} onClick={(e) =>
            this.props.switchLanguage(language)
          }>
            <i className={`flag flag-24 gx-mr-2 flag-${language.icon}`}/>
            <span className="gx-language-text">{language.name}</span>
          </li>
        )}
      </ul>
  );

  profileMenu = () => (

      <ul className="gx-sub-popover">
        <li className="gx-media gx-pointer" onClick={(e) => {
          this.props.changeApplication(false);
          this.props.clearApplications();
          this.props.userSignOut();
        }}>
          <Icon type="logout" style={{
            fontSize: '24px',
            cursor: 'pointer'
          }}/>
          <span style={{
            marginLeft: '12px',
            marginTop: '4px'
          }} className="gx-language-text">Sign Out</span>
        </li>
      </ul>
  );

  updateSearchChatUser = (evt) => {
    this.setState({
      searchText: evt.target.value,
    });
  };


  render() {
    const {locale, width, navCollapsed, navStyle, account, selectedApplication,
    wifiTests, notifications} = this.props;

    const notiLength = (notifications[account.email] || []).filter(n => !n.read).length;

    let quality, qualityClassName;
    if (selectedApplication && wifiTests && wifiTests[selectedApplication.applicationId]
    && wifiTests[selectedApplication.applicationId].length > 0) {
      const {noOfRequests, noOfNoResponseError} = wifiTests[selectedApplication.
      applicationId];
      const percentage = ((noOfRequests - noOfNoResponseError) * 100 / noOfRequests);
      quality = "good";
      qualityClassName = "gx-bg-success";

      if (percentage < 95 && percentage >= 90) {
        quality = "average";
        qualityClassName = "gx-bg-info";
      } else if (percentage < 90 && percentage >= 50) {
        quality = "bad";
        qualityClassName = "gx-bg-info";
      } else if (percentage < 50) {
        quality = "non-functioning";
      }
    }

    return (
      <Auxiliary>
        <Header>
          {navStyle === NAV_STYLE_DRAWER || ((navStyle === NAV_STYLE_FIXED || navStyle === NAV_STYLE_MINI_SIDEBAR) && width < TAB_SIZE) ?
            <div className="gx-linebar gx-mr-3">
              <i className="gx-icon-btn icon icon-menu"
                 onClick={() => {
                   this.props.toggleCollapsedSideNav(!navCollapsed);
                 }}
              />
            </div> : null}

          <div>
            <Button shape="circle"
              className="button icon-left"
              onClick={(e) => history.goBack()}
              style={{
                fontSize: '14pt',
                marginBottom: 0,
                height: '50px',
                width: '50px'
              }}>
                <Icon type="left"/>
            </Button>
          </div>
          <ul className="gx-header-notifications gx-ml-auto">
            {width >= TAB_SIZE ? null :
              <Auxiliary>
                {notifications && account &&
                  <li className="gx-notify">
                    <Popover overlayClassName="gx-popover-horizantal" placement="bottomRight" content={<AppNotification readNotification={(id) => this.props.readNotification(account.email, id)} notiList={notifications[account.email]} />}
                             trigger="click">
                      <span className="gx-pointer gx-d-block"><i className="icon icon-notification"/></span>
                    </Popover>
                  </li>
                }
              </Auxiliary>
            }
            {wifiTests && selectedApplication && wifiTests[selectedApplication.applicationId] && quality && (
              <li className="gx-language" style={{
                marginTop: '6px'
              }}>
                Last Wifi Test: <div className={qualityClassName + ' gx-badge gx-text-white'}>{quality}</div>
              </li>
            )}
            <li className="gx-language">
              <Popover overlayClassName="gx-popover-horizantal" placement="bottomRight" content={this.languageMenu()}
                       trigger="click">
                <span className="gx-pointer gx-flex-row gx-align-items-center">
                  <i className={`flag flag-24 flag-${locale.icon}`}/>
                  <span className="gx-pl-2 gx-language-name">{locale.name}</span>
                  <i className="icon icon-chevron-down gx-pl-2"/>
                </span>
              </Popover>
            </li>
            {notifications && account &&
              <li className="gx-notify">
                <Popover overlayClassName="gx-popover-horizantal" placement="bottomRight" content={<AppNotification readNotification={(id) => this.props.readNotification(account.email, id)} notiList={notifications[account.email] || []} />}
                         trigger="click">
                  <Row>
                    <Col xl={12} lg={12} md={12} sm={12} xs={12} style={{
                      margin: 'auto'
                    }}>
                      <span className="gx-pointer gx-d-block">
                        <i className="icon icon-notification"/>
                      </span>
                    </Col>
                    <Col xl={12} lg={12} md={12} sm={12} xs={12} style={{
                      margin: 'auto',
                      padding: 0,
                      fontSize: '16px'
                    }}>
                      {notiLength > 0 && <span className="gx-badge gx-badge-danger gx-text-white gx-rounded-circle">{notiLength}</span>}
                    </Col>
                  </Row>
                </Popover>
              </li>
            }
            <li>
              <div>
                <Avatar className="gx-size-50" shape="circle" alt="..." src={((account && account.avatar) ? account.avatar.url : 'https://via.placeholder.com/728x90.png?text=No+Picture')}/>
                <Popover overlayClassName="gx-popover-horizantal" placement="bottomRight" content={this.profileMenu()}
                         trigger="click">
                  <span style={{
                    fontSize: '10pt'
                  }} className="gx-pointer gx-align-items-center">
                    <i className="icon icon-chevron-down gx-pl-2"/>
                  </span>
                </Popover>
              </div>
            </li>

            {width >= TAB_SIZE ? null :
              <Auxiliary>
                <li className="gx-user-nav"><UserInfo/></li>
              </Auxiliary>
            }
          </ul>
        </Header>
      </Auxiliary>
    );
  }
}

const mapStateToProps = ({settings, auth, device, application, websocket}) => {
  const {locale, navStyle, navCollapsed, width} = settings;
  const {account} = auth;
  const {wifiTests} = device;
  const {selectedApplication} = application;
  const {notifications} = websocket;

  console.log('notifications', notifications);

  return {locale, navStyle, navCollapsed, width, account,
  wifiTests, selectedApplication, notifications};
};

export default connect(mapStateToProps, {
  toggleCollapsedSideNav,
  switchLanguage,
  changeApplication,
  clearApplications,
  userSignOut,
  fetchWifiTests,
  readNotification
})(Topbar);
